import Api from "../../services/Api";

class AssureurServices {
    async listAssureurServices() {
        return Api().get('partenaire/partners/voyage')
    }
}

export const assureurService = new AssureurServices()